<template>
  <div class="who-we-area pt-100 overflow-hidden pb-100">
    <div class="container mw-1356">
      <div class="row">
        <div class="col-xl-6">
          <div class="who-we-area-content">
            <span class="top-title">من نحن</span>
            <h2>نحن فخورون بتقديم أفضل اشتراكات IPTV</h2>
            <p class="text-body">
              توفر اشتراكاتنا أفضل تجربة بث عالي الجودة، دون تقطيع أو تأخير. 
              يمكنك التنقل بسهولة بين القنوات عبر واجهتنا سهلة الاستخدام والاستمتاع بتجربة مشاهدة سلسة لا مثيل لها.
            </p>
            <ul class="ps-0 list-unstyled we-are-list">
              <li>
                <i class="ti ti-circle-check"></i>
                <span class="text-secondary">دعم تشغيل عدة أجهزة في نفس الوقت</span>
              </li>
              <li>
                <i class="ti ti-circle-check"></i>
                <span class="text-secondary">سرعات بث فائقة وجودة تصل إلى 4K</span>
              </li>
              <li>
                <i class="ti ti-circle-check"></i>
                <span class="text-secondary">توافق كامل مع مختلف الشاشات والأجهزة</span>
              </li>
            </ul>
            <div class="d-flex align-items-center">
              <a href="#subscribe" class="btn">
                <span class="border-style">اشترك الآن</span>
              </a>

              <div class="google style-two">
                <img src="@/assets/images/google.png" alt="google" />
                <p class="mb-0">التقييم <span>4.7</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="who-we-img-wrap-two">
            <div class="row align-items-end">
              <div class="col-lg-6 col-sm-6">
                <div class="who-we-1 who-we-img">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6">
                      <div class="review mb-minus-53">
                        <div class="review-in">
                          <span>تقييمات 5 نجوم</span>
                          <h1>500K</h1>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6">
                      <div class="review bg-golden">
                        <div class="review-in">
                          <span>اشتراك نشط</span>
                          <h1>5.3K</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img src="@/assets/images/who-we-1.jpg" alt="who-we" />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6">
                <div class="who-we-2 who-we-img">
                  <img src="@/assets/images/who-we-2.jpg" alt="who-we" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // اسم متعدد الكلمات لتجنب خطأ ESLint
  name: "CompanyAbout",
});
</script>